import * as React from "react";
import { Search } from "lucide-react";
import { cn } from "../../lib/utils";
import { Input } from ".";

export const SearchInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<typeof Input> & { icon?: React.ReactNode }
>(({ className, icon, ...props }, ref) => {
  return (
    <div className="relative w-full">
      <span className="pointer-events-none absolute left-3 top-1/2 flex size-4 -translate-y-1/2 items-center justify-center text-muted-foreground [&_svg]:size-4">
        {icon ?? <Search className="size-4" />}
      </span>
      <Input ref={ref} className={cn("pl-9", className)} {...props} />
    </div>
  );
});

SearchInput.displayName = "SearchInput";
